import React, { useCallback } from 'react';

import { ReactComponent as IconBackSpaceWhite } from 'images/general/backspace-white.svg';
import { ReactComponent as IconBackSpaceDark } from 'images/general/backspace-dark.svg';

import "./Keypad.scss";

export default function KeyPad({ light, style, setStrInput, enable }) {
    const onClickH = useCallback((input) => {
        return () => {
            if (enable)
                setStrInput(s => (s + input).substring(0, 6));
        }
    }, [setStrInput, enable]);
    const onClickBackSpace = useCallback(() => {
        if (enable)
            setStrInput(s => s.substring(0, s.length - 1));
    }, [setStrInput, enable]);

    return (
        <div className={"keypad" + (light ? " light" : "") + (enable ? " enable" : "")}
            dir="ltr" style={style}>
            <div onClick={onClickH("1")}>1</div>
            <div onClick={onClickH("2")}>2</div>
            <div onClick={onClickH("3")}>3</div>
            <div onClick={onClickH("4")}>4</div>
            <div onClick={onClickH("5")}>5</div>
            <div onClick={onClickH("6")}>6</div>
            <div onClick={onClickH("7")}>7</div>
            <div onClick={onClickH("8")}>8</div>
            <div onClick={onClickH("9")}>9</div>
            {
                light ? <IconBackSpaceWhite onClick={onClickBackSpace} /> :
                    <IconBackSpaceDark onClick={onClickBackSpace} />
            }
            <div onClick={onClickH("0")}>0</div>
        </div>
    );
}